import { useEffect, useRef } from "react";
import { Flex, Form, Switch } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons"
import { getActiveSetValue, getConditionalRevertValue, shouldRevertConditionalValue } from "../../../utils/formsHelper";

const SwitchInput = (props) => {
    const { label, tooltip, helpText, mandatory, previewMode=false, readOnly, id, form, setValueData } = props

    const rules = mandatory ? [{ required: true }] : undefined;
     const disabled = previewMode && readOnly ? true : false

    const help = tooltip ? { title: helpText, icon: <QuestionCircleOutlined /> }
        : undefined;
    let activeSetValue = getActiveSetValue(setValueData)

    // Track the condition value already applied so an editable field is prefilled
    // only once. Disabled fields stay locked to the condition value.
    const lastAppliedConditionalRef = useRef(undefined)

    useEffect(() => {
        if (activeSetValue?.value) {
            const key = activeSetValue.value
            if (disabled) {
                const current = form?.getFieldValue(id)
                if (current !== key) {
                    form?.setFieldValue(id, key)
                }
            } else if (lastAppliedConditionalRef.current !== key) {
                form?.setFieldValue(id, key)
            }
            lastAppliedConditionalRef.current = key
        } else if (shouldRevertConditionalValue(activeSetValue, { disabled, currentValue: form?.getFieldValue(id), appliedValue: lastAppliedConditionalRef.current })) {
            form?.setFieldValue(id, getConditionalRevertValue(id, props.defaultFormValues))
            lastAppliedConditionalRef.current = undefined
        } else {
            lastAppliedConditionalRef.current = undefined
        }
    }, [activeSetValue, disabled, form, id])

    return (
        <>
            <div className="form-element">
                <Flex vertical>
                    <Form.Item name={id} label={label} tooltip={help} rules={rules}  className="horizontal-form-item">
                        <Switch size="small" disabled={disabled} />
                    </Form.Item>
                </Flex>
            </div>
        </>
    )
}

export default SwitchInput